/** Entry point of the phase E cks package (Liberty Square / CKS Memorial Hall and Beitou). Imported once from main.ts. */
import '../render/propsCks';
import '../render/propsCksSquare';
import '../render/propsBeitou';
import './cks';
import { registerNpcs } from '../world/npcs';
import { NPCS_CKS } from '../world/npcsCks';

registerNpcs(NPCS_CKS);
